import { useMemo } from 'react';

import { ServerError } from 'api/types/error';
import { parseFullName } from 'helpers';

interface HookResult {
  managers: {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string | null | undefined;
  }[];
  loading: boolean;
  error: ServerError | undefined;
}

export const useManagersForClients = (useGetManagers: () => HookResult) => {
  const { managers: managersApi, loading } = useGetManagers();

  const managers = useMemo(
    () =>
      managersApi.map((admin) => ({
        id: admin.id,
        name: parseFullName(admin),
      })),
    [managersApi]
  );

  return { managers, loading };
};
